/**
 * Number.prototype.format(n, x, s, c)
 * 
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function (n, x, s, c) {
	var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
		num = this.toFixed(Math.max(0, ~~n));

	return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

/**
 * String.prototype.numeroToNumber(n)
 * 
 * @param integer n: length of decimal 
 */
String.prototype.numeroToNumber = function (n) {
	var num = this.replace(/[^0-9\.,\-]/g, '').replace(/\./g, '').replace(',', '.');
	if (n) num = Number(num).toFixed(n);
	return Number(num);
};

Number.prototype.numberToNumero = function () {
	return this.format(2, 3, '.', ',');
};

String.prototype.rsPrefix = function () {
	return 'R$ ' + this;
};

/*
String.prototype.isValidDate = function () {
	if (this.length < 10) return false;
	else {
		var dataBR = this.substr(0, 10);
		var date = dataBR.split('/').reverse().join('-');
		return moment(date).isValid();
	}
};
*/

Array.prototype.max = function () {
	return Math.max.apply(null, this);
};

Array.prototype.min = function () {
	return Math.min.apply(null, this);
};

String.prototype.slugify = function () {
	return this.toString().toLowerCase()
		.replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a')       // Special Characters #1
		.replace(/[èÈéÉêÊëË]+/g, 'e')       	// Special Characters #2
		.replace(/[ìÌíÍîÎïÏ]+/g, 'i')       	// Special Characters #3
		.replace(/[òÒóÓôÔõÕöÖº]+/g, 'o')       	// Special Characters #4
		.replace(/[ùÙúÚûÛüÜ]+/g, 'u')       	// Special Characters #5
		.replace(/[ýÝÿŸ]+/g, 'y')       		// Special Characters #6
		.replace(/[ñÑ]+/g, 'n')       			// Special Characters #7
		.replace(/[çÇ]+/g, 'c')       			// Special Characters #8
		.replace(/[ß]+/g, 'ss')       			// Special Characters #9
		.replace(/[Ææ]+/g, 'ae')       			// Special Characters #10
		.replace(/[Øøœ]+/g, 'oe')       		// Special Characters #11
		.replace(/[%]+/g, 'pct')       			// Special Characters #12
		.replace(/\s+/g, '-')           		// Replace spaces with -
		.replace(/[^\w\-]+/g, '')       		// Remove all non-word chars
		.replace(/\-\-+/g, '-')         		// Replace multiple - with single -
		.replace(/^-+/, '')             		// Trim - from start of text
		.replace(/-+$/, '');            		// Trim - from end of text
};


String.prototype.isValidDateBr = function () {
	var matches = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(this);
	if (matches == null) return false;
	var d = matches[1];
	var m = matches[2] - 1;
	var y = matches[3];
	var composedDate = new Date(y, m, d);
	return composedDate.getDate() == d &&
		composedDate.getMonth() == m &&
		composedDate.getFullYear() == y;
};


